export enum MarketCategory {
  FREE = 'free',
  CAPTIVE = 'captive',
}
